import { useGooglePlacesContext } from '../context/context';

export function usePlacesService(): google.maps.places.PlacesService | undefined {
	const googlePlacesContext = useGooglePlacesContext();

	return googlePlacesContext?.placesService;
}
